import React from "react";
import { useLocation } from "react-router-dom";
import CrossArrow from "../assets/images/svg/cross-arrow.svg";

const ContactForm: React.FC = () => {
    const location = useLocation();

    return (
        <>
            {location.pathname !== "/GetQuote" && (
                <section className="contact-form-section">
                    <div className="container">
                        <div className="row form-sec-row justify-content-center">
                            <div className="col-xxl-8 col-xl-8 col-lg-8">
                                <div className="contac-form-main zoom_in" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '1.5rem', textAlign: 'center', padding: '3rem 2rem' }}>
                                    <h3 style={{ fontSize: '2rem', fontWeight: 700, margin: 0 }}>Zarezerwuj sprzątanie online</h3>
                                    <p style={{ color: '#6b7280', fontSize: '1.1rem', margin: 0 }}>Wybierz termin, wpisz adres i opłać rezerwację w kilka minut – bez dzwonienia.</p>
                                    <a
                                        href="https://widget.sprzatasia.pl/"
                                        target="_blank"
                                        rel="noreferrer"
                                        className="btn-quote"
                                        style={{ fontSize: '1.1rem', padding: '1rem 2.5rem' }}
                                    >
                                        Zamów sprzątanie
                                        <img src={CrossArrow} alt="cross-arrow" />
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            )}
        </>
    );
};

export default ContactForm;
